import api from 'API/index'

import {
  SET_ADMIN_INFO,
  SET_TOKEN_INFO
} from '../mutation-types'

import {
  saveAccessToken,
  getAccessToken,
  cachedAdminInfo,
  removeAccessToken,
  cachedKeysData
} from 'API/cacheService'

const state = {
  token: getAccessToken() || {},
  adminInfo: cachedAdminInfo.load() || cachedKeysData.adminInfo
}

const getters = {
  token (state) {
    return state.token
  },
  adminInfo (state) {
    return state.adminInfo
  }
}

const mutations = {
  [SET_TOKEN_INFO] (state, data) {
    state.token = data
  },
  [SET_ADMIN_INFO] (state, data) {
    state.adminInfo = data
  }
}

const actions = {
  /**
   * 获取栏目列表
   */
  getColumn (store, params) {
    return api.getColumn(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取单个栏目列表
   */
  getOneColumn (store, params) {
    return api.getOneColumn(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 添加栏目
   */
  addColumn (store, params) {
    return api.addColumn(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 删除文件
   */
  delfile (store, params) {
    return api.delfile(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 设置栏目
   */
  saveColumn (store, params) {
    return api.saveColumn(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 删除栏目
   */
  delColumn (store, params) {
    return api.delColumn(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 添加视频文章
   */
  addVideo (store, params) {
    return api.addVideo(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取视频栏目分类
   */
  getVideoType (store, params) {
    return api.getVideoType(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 视频文章分页获取
   */
  getArticleAllVideo (store, params) {
    return api.getArticleAllVideo(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 修改文章状态（视频）
   */
  saveArticleVideoState (store, params) {
    return api.saveArticleVideoState(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 删除文章（视频）
   */
  delArticleVideo (store, params) {
    return api.delArticleVideo(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取单个文章（视频）
   */
  getOneArticleVideo (store, params) {
    return api.getOneArticleVideo(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 修改文章内容（视频）
   */
  saveArticleVideo (store, params) {
    return api.saveArticleVideo(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取账号分页数据
   */
  getAdminAll (store, params) {
    return api.getAdminAll(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 删除账户
   */
  delAdmin (store, params) {
    return api.delAdmin(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 添加账户
   */
  addAdmin (store, params) {
    return api.addAdmin(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 设置账户状态
   */
  saveAdmin (store, params) {
    return api.saveAdmin(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取单个账户信息
   */
  getOneAdmin (store, params) {
    return api.getOneAdmin(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 设置账户信息
   */
  upAdmin (store, params) {
    return api.upAdmin(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 设置账户信息
   */
  addHelp (store, params) {
    return api.addHelp(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取帮助信息ALL
   */
  getHelpAll (store, params) {
    return api.getHelpAll(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取单条帮助信息
   */
  getOneHelp (store, params) {
    return api.getOneHelp(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 修改帮助信息
   */
  upHelp (store, params) {
    return api.upHelp(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 删除帮助信息
   */
  delHelp (store, params) {
    return api.delHelp(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 设置系统基本参数
   */
  saveSystem (store, params) {
    return api.saveSystem(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取系统基本参数
   */
  getSystem (store, params) {
    return api.getSystem(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 添加文章
   */
  addArticle (store, params) {
    return api.addArticle(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取文章分页数据
   */
  getArticleAll (store, params) {
    return api.getArticleAll(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 修改文章状态
   */
  saveArticleState (store, params) {
    return api.saveArticleState(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 删除文章
   */
  delArticle (store, params) {
    return api.delArticle(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取单个文章
   */
  getOneArticle (store, params) {
    return api.getOneArticle(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 修改文章
   */
  saveArticle (store, params) {
    return api.saveArticle(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取短信剩余条数
   */
  getSmsNum (store, params) {
    return api.getSmsNum(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取发送短信记录
   */
  getSmsSendingList (store, params) {
    return api.getSmsSendingList(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 添加医生
   */
  addDoctor (store, params) {
    return api.addDoctor(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 后台查看专家分页
   */
  getDoctorAll (store, params) {
    return api.getDoctorAll(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 医生状态修改
   */
  saveDoctorState (store, params) {
    return api.saveDoctorState(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 删除医生
   */
  delDoctor (store, params) {
    return api.delDoctor(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取单个医生信息
   */
  getOneDoctor (store, params) {
    return api.getOneDoctor(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 修改医生信息
   */
  saveDoctor (store, params) {
    return api.saveDoctor(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 退出登录
   */
  exitlogin (store, params) {
    return api.exitlogin(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取文章分类
   */
  getArticleTyps (store, params) {
    return api.getArticleTyps(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取挂号分页
   */
  getRegisterList (store, params) {
    return api.getRegisterList(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取医生列表
   */
  getDoctorData (store, params) {
    return api.getDoctorData(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取首页显示数据
   */
  getIndexData (store, params) {
    return api.getIndexData(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取微信用户分页
   */
  getWxUserAll (store, params) {
    return api.getWxUserAll(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取微信用户地域列表
   */
  getAreaData (store, params) {
    return api.getAreaData(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取指定分类文章ALL
   */
  getArticleTypsAll (store, params) {
    return api.getArticleTypsAll(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 后台获取小程序路由
   */
  getWechatRoute (store, params) {
    return api.getWechatRoute(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 后台添加小程序路由
   */
  addWechatRoute (store, params) {
    return api.addWechatRoute(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 后台删除小程序路由
   */
  delWechatRoute (store, params) {
    return api.delWechatRoute(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 后台修改小程序路由
   */
  saveWechatRoute (store, params) {
    return api.saveWechatRoute(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 后台获取消息模板数据
   */
  getNewsMould (store, params) {
    return api.getNewsMould(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 后台添加消息模板
   */
  addNewsMould (store, params) {
    return api.addNewsMould(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 后台删除消息模板
   */
  delNewsMould (store, params) {
    return api.delNewsMould(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 后台修改消息模板
   */
  saveNewsMould (store, params) {
    return api.saveNewsMould(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 消息推送初始化数据
   */
  getNewsPushData (store, params) {
    return api.getNewsPushData(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 添加小程序路由组件初始化数据获取
   */
  getWechatRouterAddData (store, params) {
    return api.getWechatRouterAddData(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取指定模板id可推送的用户信息
   */
  getMouldPushUser (store, params) {
    return api.getMouldPushUser(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 检测模板是否符合发送规则并发送
   */
  testingMouldPush (store, params) {
    return api.testingMouldPush(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取推送任务列表
   */
  getPushTaskList (store, params) {
    return api.getPushTaskList(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取推送任务列表
   */
  getModular (store, params) {
    return api.getModular(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 保存推送任务列表
   */
  setModular (store, params) {
    return api.setModular(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取小程序首页模块数据
   */
  getInitialData (store, params) {
    return api.getInitialData(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取小程序病种页模块数据
   */
  getDiseaseData (store, params) {
    return api.getDiseaseData(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 保存首页模块排序
   */
  setInitialData (store, params) {
    return api.setInitialData(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 获取小程序链接
   */
  pushWxUrlData (store, params) {
    return api.pushWxUrlData(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
  /**
   * 向微信服务器推送小程序页面链接，加速收录
   */
  pushWxUrl (store, params) {
    return api.pushWxUrl(params)
      .then((data) => {
        return Promise.resolve(data)
      })
      .catch((error) => {
        return Promise.reject(error)
      })
  },
	/**
	 * 后台获取短信模板
	 */
	getSmsMould (store, params) {
	  return api.getSmsMould(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 后台添加短信模板
	 */
	addSmsMould (store, params) {
	  return api.addSmsMould(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 后台删除短信模板
	 */
	delSmsMould (store, params) {
	  return api.delSmsMould(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 后台修改短信模板
	 */
	saveSmsMould (store, params) {
	  return api.saveSmsMould(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 获取发送短信数据
	 */
	getSmsPushData (store, params) {
	  return api.getSmsPushData(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 推送短信
	 */
	setSmsPushData (store, params) {
	  return api.setSmsPushData(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 获取用户病例数据(分页查询)
	 */
	getWxUserCaseData (store, params) {
	  return api.getWxUserCaseData(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},
	/**
	 * 获取单个用户病例数据
	 */
	getWxUserCaseOneData (store, params) {
	  return api.getWxUserCaseOneData(params)
	    .then((data) => {
	      return Promise.resolve(data)
	    })
	    .catch((error) => {
	      return Promise.reject(error)
	    })
	},

}

export default {
  state,
  mutations,
  actions,
  getters
}


// WEBPACK FOOTER //
// ./src/store/modules/admin.js